import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { ColloquioConoscitivoDTO } from '../../shared/dto/colloquio/colloquio-conoscitivo';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/shared/GenericService';

@Injectable({
  providedIn: 'root'
})
export class ColloquioConoscitivoService extends GenericService<ColloquioConoscitivoDTO, number>{

  constructor(http: HttpClient) {
    super(http);
    this.url = environment.urlPrefix + '/services/rest/json/colloquio-conoscitivo';
  }

  public colloquioList(pageNumber: number, pageSize: number, direction: string, sortField: string, filter: string): Observable<ResponseQueryByCriteria<ColloquioConoscitivoDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    if (filter != null) params["filter"] = filter;
    return this.http.get<ResponseQueryByCriteria<ColloquioConoscitivoDTO>>(`${this.url}/colloquioList`, {
      params: params
    });
  }
}